import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { MaterialCatalogueListItem } from 'src/app/core/models/client-models';
import { TableColumn } from '../../../../core/models/table-column';

@Component({
  selector: 'app-material-catalog-list-item',
  templateUrl: './material-catalog-list-item.component.html',
  styleUrls: ['./material-catalog-list-item.component.scss'],
})
export class MaterialCatalogListItemComponent implements OnInit {
  @Input() materialCatalogueList$: Observable<MaterialCatalogueListItem[]>;
  @Input() tableColumns$: Observable<TableColumn[]>;
  @Input() selectedIndex$: Observable<number>;

  @Output() onClickEvent = new EventEmitter<MaterialCatalogueListItem>();
  @Output() onHoverEvent = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  onHover(index: number) {
    this.onHoverEvent.emit(index);
  }

  onClick(row: MaterialCatalogueListItem) {
    this.onClickEvent.emit(row);
  }
}
